/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import { UserLoggedIn } from '../../../app/hooks/PermissionChecker';
import { useLocation } from 'react-router-dom';
import { OpeningConfigModal } from '../../../app/pages/dashboard/_modals/OpeningConfigModal';
import { ModalModel } from '../../../app/models/CommonModel';
import { ShareProductsRulesModal } from '../../../app/pages/dashboard/_modals/ShareProductsRulesModal';

const CheckStoreConfig: FC = () => {
  const location = useLocation();
  const user = UserLoggedIn();

  const [openingConfigModal, setOpeningConfigModal] = useState<ModalModel>({
    show: false,
    mode: 'add',
  });

  const [allowShareProductsModal, setAllowShareProductsModal] = useState<ModalModel>({
    show: false,
    mode: 'add',
  });

  useEffect(() => {
        checkOpeningConfig();
    }, [location]);
  
  const checkOpeningConfig = async () => {
    const storeData = user?.store;
    if (storeData && !storeData.open_store_config ) {
      setOpeningConfigModal({...openingConfigModal, show: true});
      return;
    }
  }

  const handleShowShareProductRules = () => {
    setOpeningConfigModal({...openingConfigModal, show: false});
    setAllowShareProductsModal({...openingConfigModal, show: true});
  }

  const [isApproveShare, setIsApproveShare] = useState<boolean>();
    const handleApproveShare = () => {
        setIsApproveShare(true);
        setAllowShareProductsModal({...allowShareProductsModal, show: false})
        setOpeningConfigModal({...openingConfigModal, show: true})
    }

  return (
    <>
      <OpeningConfigModal
        {...openingConfigModal}
        handleClose={() => {
          setIsApproveShare(undefined)
          setOpeningConfigModal({...openingConfigModal, show: false})
        }}  
        handleShowShareProductRules={handleShowShareProductRules}
        isApproveShare={isApproveShare}
      />
      <ShareProductsRulesModal
        {...allowShareProductsModal}
        handleClose={() => setAllowShareProductsModal({...allowShareProductsModal, show: false})} 
        handleApprove={handleApproveShare} 
      />
    </>
  )
}

export {CheckStoreConfig}
